import { useEffect, useState } from 'react';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import { DateFormatter, NameFormatter } from '../../shared/controls/formatters';
import TruncatedText from '../../shared/component/TruncateText';

function getDifferences(oldData, newData) {
  const diffs = {};
  for (const key in newData) {
    if (newData.hasOwnProperty(key)) {
      const oldValue = oldData[key];
      const newValue = newData[key];

      if (oldValue != newValue) {
        const isDateField = key.toLowerCase().includes('date');

        diffs[key] = {
          old: isDateField ? DateFormatter(oldValue) : oldValue,
          new: isDateField ? DateFormatter(newValue) : newValue,
        };
      }
    }
  }

  return diffs;
}

const Timeline = ({ localData, module }) => {
  const [loading, setLoading] = useState(true);
  const [historyData, setHistoryData] = useState([]);

  useEffect(() => {
    if (loading && localData?.id) {
      const fetchData = async () => {
        try {
          const data = {
            moduleType: module,
            moduleId: localData?.id,
          };
          const response = await apiServices.getModuleTimeline(data);
          if (response.status === 200) {
            setHistoryData(response.data.timelinelist);
          } else {
            toast.error(`An unexpected error occurred: ${response.status}`, {
              position: 'top-right',
            });
          }
        } catch (error) {
          console.error('Error fetching data:', error);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }
  }, [localData?.id, module, loading]);

  // Group timeline items by formatted date.
  const groupedTimeline = historyData.reduce((groups, item) => {
    const oldData = JSON.parse(item.oldJson || '{}');
    const currentData = JSON.parse(item.currentJson || '{}');

    const createdAt = currentData.UpdatedDateTime || oldData.UpdatedDateTime || null;

    const formattedDate = createdAt ? new Date(createdAt).toLocaleDateString() : 'Unknown Date';

    const formattedTime = createdAt ? new Date(createdAt).toLocaleTimeString() : 'Unknown Time';

    const differences = getDifferences(oldData, currentData);
    const userName = currentData.UpdatedBy ? currentData.UpdatedBy : 'Unknown User';

    const timelineItem = {
      formattedTime,
      differences,
      userName,
    };

    if (!groups[formattedDate]) {
      groups[formattedDate] = [];
    }
    groups[formattedDate].push(timelineItem);
    return groups;
  }, {});

  const sortedDates = Object.keys(groupedTimeline).sort((a, b) => new Date(b) - new Date(a));

  return (
    <div className="infoBox">
      <div className="addlead-header">
        <label className="flex-div align-items-center">
          <img className="me-2" src="../assets/images/timelineIcon.svg" alt="" />
          Timeline
        </label>
      </div>
      <div className="leadcontent">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12">
            <div className="Timeline_CRM">
              {loading ? (
                <p>Loading timeline...</p>
              ) : sortedDates.length > 0 ? (
                sortedDates.map((date) => (
                  <div key={date} className="timeline-group">
                    <div className="audit-date">{date}</div>
                    {groupedTimeline[date].map((entry, idx) => (
                      <div key={idx} className="audit-timeline">
                        <div className="timeline-item">
                          <div className="timeline-line"></div>
                          <div className="timeline-dot">
                            <img src="/assets/images/laptop.svg" alt="" width="16px" />
                          </div>
                          <div className="time">{entry?.formattedTime}</div>
                          <div className="userNameBlock">
                            <p className="user-name">
                              Changes made by{' '}
                              <span>{NameFormatter(entry?.userName) || 'Unknown User'}</span>
                            </p>
                            <span className="actionTimeline">
                              <div>
                                {Object.keys(entry?.differences)
                                  .filter(
                                    (key) =>
                                      key !== 'UpdatedDateTime' &&
                                      key !== 'DomainEvents' &&
                                      key !== 'AuditableRequestName' &&
                                      key !== 'TagsRaw' &&
                                      key !== 'FullName' &&
                                      key !== 'UpdatedBy' &&
                                      (!key.toLowerCase().endsWith('id') || key === 'SkypeId')
                                  )
                                  .map((key) => (
                                    <div key={key} className="dataValueBlock">
                                      <h4>{key}:</h4>
                                      <div className="dataChangesValue">
                                        <span>From:</span>
                                        <span className="oldValue">
                                          <TruncatedText
                                            value={entry?.differences?.[key]?.old}
                                            limit={60}
                                          />
                                        </span>
                                        <span>To:</span>

                                        <span className="newValue">
                                          <TruncatedText
                                            value={entry?.differences?.[key]?.new}
                                            limit={60}
                                          />
                                        </span>
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))
              ) : (
                <div className="noDataAvailable">
                  <div className="noDataCont">
                    <img src="../assets/images/empty-box.png" alt="" />
                    <p>No timeline history available.</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timeline;
